const lookbookReturnKey = 'lookbookReturnUrl';

const updateDrawerUrl = (drawer, isOpen) => {
  const url = new URL(window.location.href);
  const lookbookName = drawer.dataset.activeLookbook;
  if (!lookbookName) return;

  if (isOpen) {
    url.searchParams.set('lookbook', lookbookName);
  } else if (url.searchParams.get('lookbook') === lookbookName) {
    url.searchParams.delete('lookbook');
  } else {
    return;
  }

  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`
  );
};

const drawer = document.querySelector('slide-drawer[id^="lookbook-drawer-"]');
let activeProductRequest;
if (drawer) {
  new MutationObserver(() => {
    updateDrawerUrl(drawer, drawer.classList.contains('open'));
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  const drawer = link?.closest('[data-lookbook-return]');
  if (drawer) {
    sessionStorage.setItem(lookbookReturnKey, drawer.dataset.lookbookReturn);
  }
}, true);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-lookbook-open]');
  if (!trigger) return;

  openLookbook(
    trigger.dataset.lookbookName,
    trigger.dataset.lookbookTitle,
    trigger.dataset.lookbookReturn,
    trigger.dataset.lookbookProductHandles,
    trigger.dataset.productUrlBase,
    event.detail === 0
  );
});

async function openLookbook(lookbookName, title, returnUrl, productHandlesJson, productUrlBase, openedViaKeyboard = false, returnScrollPosition = null) {
  if (!drawer || !lookbookName) return;

  const productsContainer = drawer.querySelector('[data-lookbook-drawer-products]');
  if (!productsContainer || !productUrlBase) return;

  drawer.dataset.activeLookbook = lookbookName;
  drawer.dataset.lookbookReturn = returnUrl || `${window.location.pathname}?lookbook=${encodeURIComponent(lookbookName)}`;
  drawer.querySelector('[data-lookbook-drawer-title]').textContent = title || '';
  productsContainer.textContent = 'Loading products...';
  drawer.open(openedViaKeyboard);
  if (returnScrollPosition !== null) {
    drawer.scrollPosition = returnScrollPosition;
    document.body.style.top = `-${returnScrollPosition}px`;
  }

  activeProductRequest?.abort();
  activeProductRequest = new AbortController();

  try {
    const productHandles = JSON.parse(productHandlesJson || '[]') || [];
    if (productHandles.length === 0) {
      productsContainer.textContent = 'No products available.';
      return;
    }

    const productCards = await Promise.all(productHandles.map(async (handle) => {
      const url = `${productUrlBase}${encodeURIComponent(handle)}?view=lookbook-card`;
      const response = await fetch(url, { signal: activeProductRequest.signal });
      if (!response.ok) throw new Error(`Product card request failed: ${response.status}`);
      return response.text();
    }));

    if (drawer.dataset.activeLookbook !== lookbookName) return;
    productsContainer.innerHTML = productCards.join('');
    productsContainer.querySelectorAll('script').forEach((script) => script.remove());

    if (productsContainer.querySelector('deferred-carousel')) {
      await import('./deferred-product-images.js');
    }

    const videos = productsContainer.querySelectorAll('video-element video');
    if (videos.length) {
      await import('./video-element.js');
      videos.forEach((video) => {
        video.poster = window.innerWidth >= 1024
          ? video.dataset.poster
          : video.dataset.posterMobile || video.dataset.poster;
      });
    }
  } catch (error) {
    if (error.name === 'AbortError' || drawer.dataset.activeLookbook !== lookbookName) return;
    productsContainer.textContent = 'Products could not be loaded.';
    console.error(error);
  }
}

const lookbookName = new URLSearchParams(window.location.search).get('lookbook');
if (lookbookName) {
  const trigger = Array.from(document.querySelectorAll('[data-lookbook-name]'))
    .find((item) => item.dataset.lookbookName === lookbookName);
  if (trigger) {
    const returnTarget = window.location.hash
      ? document.getElementById(window.location.hash.slice(1))
      : null;
    const returnScrollPosition = returnTarget
      ? returnTarget.getBoundingClientRect().top + window.scrollY
      : null;

    openLookbook(
      trigger.dataset.lookbookName,
      trigger.dataset.lookbookTitle,
      trigger.dataset.lookbookReturn,
      trigger.dataset.lookbookProductHandles,
      trigger.dataset.productUrlBase,
      false,
      returnScrollPosition
    );
  }
  sessionStorage.removeItem(lookbookReturnKey);
}

const lookbookBackLink = document.querySelector('[data-lookbook-back]');
const lookbookReturnUrl = sessionStorage.getItem(lookbookReturnKey);
if (lookbookBackLink && lookbookReturnUrl) {
  lookbookBackLink.href = lookbookReturnUrl;
  lookbookBackLink.hidden = false;
  lookbookBackLink.addEventListener('click', () => {
    sessionStorage.removeItem(lookbookReturnKey);
  }, { once: true });
}
